import { useEffect, lazy, Suspense } from "react";
import { useSearchParams } from "react-router-dom";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ProductCarouselSection from "@/components/ProductCarouselSection";
import BottomNav from "@/components/BottomNav";
import FloatingCheckout from "@/components/FloatingCheckout";

const FeaturesSection = lazy(() => import("@/components/FeaturesSection"));
const SizeUpSection = lazy(() => import("@/components/SizeUpSection"));
const PromoBanner = lazy(() => import("@/components/PromoBanner"));
const CombosSection = lazy(() => import("@/components/CombosSection"));
const ReviewsSection = lazy(() => import("@/components/ReviewsSection"));
const AboutTeaser = lazy(() => import("@/components/AboutTeaser"));
const DealerCTA = lazy(() => import("@/components/DealerCTA"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const scrollTarget = searchParams.get("scroll");
    if (scrollTarget) {
      const timer = setTimeout(() => {
        const el = document.getElementById(scrollTarget);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen pb-20 md:pb-0 overflow-x-hidden w-full relative bg-white">
      <Navbar />
      <main id="main-content">
        <HeroSection />
        <ProductCarouselSection />
        <Suspense fallback={<div className="w-full h-32 animate-pulse bg-gray-50" />}>
          <PromoBanner />
          <CombosSection />
          <FeaturesSection />
          <AboutTeaser />
          <SizeUpSection />
          <ReviewsSection />
          <DealerCTA />
        </Suspense>
      </main>
      <Suspense fallback={<div className="w-full h-32 animate-pulse bg-gray-50" />}>
        <Footer />
      </Suspense>
      <BottomNav />
      <FloatingCheckout />
    </div>
  );
};

export default Index;
